import { createContext, useContext, useState, type ReactNode } from 'react'

interface BeeldPickerContextType {
	isOpen: boolean
	setIsOpen: (open: boolean) => void
}

export const BeeldPickerContext = createContext<
	BeeldPickerContextType | undefined
>(undefined)

export function BeeldPickerProvider({ children }: { children: ReactNode }) {
	const [isOpen, setIsOpen] = useState(false)

	return (
		<BeeldPickerContext.Provider value={{ isOpen, setIsOpen }}>
			{children}
		</BeeldPickerContext.Provider>
	)
}

export function useBeeldPicker() {
	const context = useContext(BeeldPickerContext)
	if (context === undefined) {
		throw new Error('useBeeldPicker must be used within a BeeldPickerProvider')
	}
	return context
}
